import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/Modal";
import AthleteScore from "../../../components/athlete-scores/athlete-score";

const CoachDetails = ({
  selectedCoach,
  backButtonClickEvent,
  athletesLiked = [],
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAthlete, setSelectedAthlete] = useState(null);

  useEffect(() => {
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleViewClick = (athlete) => {
    setSelectedAthlete(athlete);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedAthlete(null);
  };

  return (
    <>
      <div className="bg-white p-4 border-gray-300 rounded-md shadow-lg h-full">
        <div className="athletes-list h-full event_details_mob md:absolute xl:relative lg:relative md:col-span-7 xl:col-span-7 xl:space-y-0 xl:bg-transparent xl:border-gray-300 p-0 md:space-y-0 md:top-0 xl:top-0 lg:top-0">
          <div className="text-blue-600 pt-6 px-6 md:visible xl:hidden lg:hidden sm:visible">
            <NavLink onClick={() => backButtonClickEvent(false)}>
              <FontAwesomeIcon icon={faChevronLeft} /> Back
            </NavLink>
          </div>
          <div className="p-4 xl:p-0 lg:p-0">
            <div className="flex flex-col md:flex-row text-xl uppercase flex-1">
              <div className="my-auto">
                <img
                  alt={`${selectedCoach.firstName} ${selectedCoach.lastName}`}
                  src={
                    selectedCoach.profilePicture || "/default-profile-img.png"
                  }
                  className="grow-0 shrink-0 rounded-md w-24 h-24"
                />
              </div>
              <div className="ml-4 flex-1">
                <p className="text-lg">
                  {selectedCoach.name} {selectedCoach.lastname}
                </p>
                <p className="text-sm text-gray-700">
                  {selectedCoach.university || "No university listed."}
                </p>
              </div>
            </div>
            <h3 className="text-xl font-medium mt-6 mb-4 ">
              Favorite Athletes
            </h3>
            <div className="h-[calc(100dvh-300px)] overflow-auto pr-4 -mr-4">
              <ul className="">
                {athletesLiked.length > 0 ? (
                  athletesLiked.map((athlete) => (
                    <li
                      key={athlete.userAthleteId}
                      className="flex justify-between items-center border p-3 rounded-lg shadow-sm mb-2"
                    >
                      <div className="flex items-center">
                        <img
                          alt={`${athlete.name} ${athlete.lastname}`}
                          src={
                            athlete.profilePicture || "/default-profile-img.png"
                          }
                          className="h-[40px] w-[40px] mr-2 rounded-md"
                        />
                        <div className="flex flex-col mr-4">
                          <span className="text-base lg:text-lg">
                            {athlete.name} {athlete.lastname}
                          </span>
                          <span className="text-sm text-gray-700">
                            {athlete.position}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center justify-end space-x-8">
                        <span className="flex items-center justify-center  h-[32px] xl:h-[40px] w-[32px] xl:w-[40px] rounded-full bg-yellow-500">
                          <FontAwesomeIcon
                            icon={faThumbsUp}
                            style={{ color: "#fff" }}
                          />
                        </span>

                        <span className="text-lg font-semibold bg-700 text-white px-2 py-1 rounded mr-2 hidden">
                          {athlete.trackittScore}
                        </span>
                        <button
                          onClick={() => handleViewClick(athlete)}
                          className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-700 text-sm"
                        >
                          VIEW
                        </button>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="flex justify-center items-center h-32">
                    <span className="text-lg text-gray-500">
                      No favorite athletes marked.
                    </span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        {selectedAthlete && (
          <AthleteScore
            userId={selectedAthlete.userId}
            showOffers={true}
            showTrackittScore={true}
            showPositionScore={true}
            searchEvent={false}
            showProfile={true}
            showRank={true}
            showLikes={true}
          />
        )}
      </Modal>
    </>
  );
};

export default CoachDetails;
